import React from 'react';
import './layout.scss';
import SidebarSection from './SidebarSection';
import PageSection from './PageSection';

// Presentational component to display the main page body.
//  Passes props to SidebarSection and PageSection. 
//   (So might be a candidate for refactoring using a container component to give the children access to the data)
//
function Body(props) {
  var mainDivClass = "container-fluid aa-main-body " + (props.page.className || '');
  return(
    <div className={mainDivClass}>
      <div className="row">
        <SidebarSection page={props.page} contentComponent={props.sidebarComponent} />      
        <PageSection page={props.page} contentComponent={props.contentComponent} onContinue={props.onContinue}/>      
      </div>
    </div>
  );
}
 
export default Body;
